/**
 * Class constants for the popover surface.
 */

export const popoverStyles = {
  trigger:
    'inline-flex items-center justify-center gap-2 rounded-control border border-border-strong bg-surface-raised px-3 py-2 text-sm font-medium text-content transition-colors hover:bg-surface-sunken disabled:pointer-events-none disabled:opacity-50',

  popup:
    'z-50 w-72 max-w-[calc(100vw-2rem)] rounded-surface border border-border bg-surface-raised p-4 text-content shadow-lg transition-opacity duration-100 data-[starting-style]:opacity-0 data-[ending-style]:opacity-0',

  title: 'text-sm font-semibold text-content',

  description: 'mt-1 text-sm text-content-muted',

  close:
    'inline-flex items-center justify-center rounded-control border border-border-strong bg-surface-raised px-2 py-1 text-sm font-medium text-content transition-colors hover:bg-surface-sunken',

  arrow: 'block fill-surface-raised stroke-border',
} as const;